













































































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import Draggable from 'vuedraggable'
import KanbanChangeDialog from '@/components/cockpit/KanbanChangeDialog.vue'
import KanbanDialog from '@/components/cockpit/KanbanDialog.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import RecruitingDetailDialog from '@/components/recruiting/RecruitingDetailDialog.vue'

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  kanbanData: any[]
  showDeleteWarningDialog: boolean
  warningDeleteMessage: string
  showKanbanChangeDialog: boolean
  kanbanChangeDialogLabel: string
  showKanbanDialog: boolean
  kanbanDialogLabel: string
  draggedElementData: any
  draggedFromId: any
  draggedFromIndex: any

  showRecruitingDialog: boolean
  recruitingData: any
}

export default Vue.extend({
  name: 'Kanban',

  components: {
    RecruitingDetailDialog,
    Draggable,
    WarningDialog,
    KanbanDialog,
    KanbanChangeDialog
  },

  props: {
    selectedTask: Object as () => any | null,
    isKanbanCreate: Boolean,
    isKanbanEdit: Boolean,
    isKanbanDelete: Boolean
  },

  data (): ComponentData {
    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      kanbanData: [],
      showDeleteWarningDialog: false,
      warningDeleteMessage: 'DELETE',
      showKanbanChangeDialog: false,
      kanbanChangeDialogLabel: '',
      showKanbanDialog: false,
      kanbanDialogLabel: '',
      draggedElementData: null,
      draggedFromId: null,
      draggedFromIndex: null,

      showRecruitingDialog: false,
      recruitingData: null
    }
  },

  watch: {
    isKanbanCreate (newVal: boolean): void {
      if(newVal) {
        this.showKanbanDialog = true
      }
    },

    isKanbanEdit (newVal: boolean): void {
      if(newVal) {
        const foundColumn: any | undefined = this.kanbanData.find((column: any) => column.items.includes(this.selectedTask))
        this.kanbanDialogLabel = foundColumn ? foundColumn.name : ''

        this.showKanbanDialog = true
      }
    },

    isKanbanDelete (newVal: boolean): void {
      if(newVal) {
        this.showDeleteWarningDialog = true
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    getTaskByStatus (status: number): any[] {
      return this.kanbanData.filter((item: any) => item.status === status)
    },

    showRecruiting (): void {
      this.showRecruitingDialog = true
    },

    onRecruitingDialogClose (): void {
      this.showRecruitingDialog = false
    },

    onCloseKanbanDialog (): void {
      this.$emit('stopCreate')
      this.$emit('stopEdit')
      this.showKanbanDialog = false
    },

    onSaveKanbanDialog (): void {
      this.onCloseKanbanDialog()
    },

    onWarningDeleteDialogClose (): void {
      this.$emit('stopDelete')
      this.showDeleteWarningDialog = false
    },

    onWarningDeleteDialogSave (): void {
      this.onWarningDeleteDialogClose()
    },

    onTaskClick (item: any): void {
      this.$emit('selectTask', this.selectedTask && this.selectedTask.id === item.id ? null : item)
    },

    onDblTaskClick (item: any, i: any): void {
      this.$emit('selectTask', i)
      this.kanbanDialogLabel = item.name
      this.showKanbanDialog = true
    },

    onMove(evt: any) {
      this.draggedElementData = evt.draggedContext.element
      const fromList: any | undefined = this.kanbanData.find((column: any) => column.items.includes(this.draggedElementData))
      this.draggedFromId = fromList.id
      this.draggedFromIndex = fromList.items.indexOf(this.draggedElementData)

      return true
    },

    draggableChange (evt: any): void {
      const toList: any | undefined = this.kanbanData.find((column: any) => column.items.includes(this.draggedElementData))
      this.kanbanChangeDialogLabel = toList ? toList.name : ''
      this.showKanbanChangeDialog = true
    },

    onCloseKanbanChangeDialog (): void {
      this.showKanbanChangeDialog = false
      const fromList: any | undefined = this.kanbanData.find((column: any) => column.id === this.draggedFromId)
      const toList: any | undefined = this.kanbanData.find((column: any) => column.items.includes(this.draggedElementData))
      if (fromList && toList) {
        const indexInToList = toList.items.indexOf(this.draggedElementData)
        if (indexInToList > -1) {
          toList.items.splice(indexInToList, 1)
        }
        fromList.items.splice(this.draggedFromIndex, 0, this.draggedElementData)
      }
    },

    onSaveKanbanChangeDialog (): void {
      this.showKanbanChangeDialog = false
    },
  },

  created (): void {

  },

  mounted() {

    const data: any[] = [
      { id: 1, name: 'Neue Bewerbung', color: 'rgba(33, 150, 243)', color2: 'rgba(33, 150, 243, 0.2)', items: [
          {id: 11, vorname: `Peter` , name: `Krnáč`, date: '13.08.2025 10:00', responsible: 'Eva Cronauer', status: 1},
          {id: 12, vorname: `Jana` , name: `Vajglova`, date: '01.08.2025 18:00', responsible: 'Eva Cronauer', status: 1},
          {id: 13, vorname: `Mirelinda` , name: `Palushaj`, date: '20.04.2025 20:00', responsible: 'Eva Cronauer', status: 1}
        ] },
      { id: 2, name: 'Kontakt', color: 'rgba(33, 150, 243)', color2: 'rgba(33, 150, 243, 0.2)', items: [] },
      { id: 3, name: 'Unterlagen', color: 'rgba(33, 150, 243)', color2: 'rgba(33, 150, 243, 0.2)', items: [] },
      { id: 4, name: 'Abklärungen', color: 'rgba(255, 152, 0)', color2: 'rgba(255, 152, 0, 0.2)', items: [
          {id: 41, vorname: `Anett` , name: `Fodor`, date: '13.08.2025 07:45', responsible: 'Eva Cronauer', status: 4},
          {id: 42, vorname: `Ruth`, name: `Oswald`, date: '01.08.2025 15:59', responsible: 'Eva Cronauer', status: 4},
        ] },
      { id: 5, name: 'Vorstellungsgespräch', color: 'rgba(255, 152, 0)', color2: 'rgba(255, 152, 0, 0.2)', items: [] },
      { id: 6, name: 'Probearbeiten', color: 'rgba(255, 152, 0)', color2: 'rgba(255, 152, 0, 0.2)', items: [
          {id: 61, vorname: `Shirin`, name: `Arfo`, date: '20.04.2025 16:30', responsible: 'Eva Cronauer', status: 4},
        ] },
      { id: 7, name: 'Vertragsabschluss', color: 'rgba(76, 175, 80)', color2: 'rgba(76, 175, 80, 0.2)', items: [
          {id: 71, vorname: `Ouafae`, name: `Azzouz`, date: '20.04.2025 09:20', responsible: 'Eva Cronauer', status: 4},
        ] },
      { id: 8, name: 'Absage', color: 'rgba(244, 67, 54)', color2: 'rgba(244, 67, 54, 0.2)', items: [] },
    ]

    this.kanbanData = data

  }
})
